import styled from "styled-components";

export const Main = styled.div`
   position: absolute;
   top: 15px;
   z-index: 999;

   > ul {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgb(255 255 255 / 0.95);
      border-radius: 15px;
      border: 1px solid rgba(0, 0, 0, 0.1);
      border-top: none;
      font-size: 15px;
      height: 45px;
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);

      li {
         display: flex;
         padding: 5px 15px;
         cursor: pointer;
         transition: all .2s ease-in-out;

         &:first-of-type {
            span {
               position: relative;
               margin-left: 5px;
            }
         }
         &.running {
            color: #922E27;

            svg {
               animation: run 1.1s infinite linear;
               margin-right: 3px;
               margin-top: 2px;

               @keyframes run  {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
               }
            }
         }
         &.loop {
            color: #922E27;

            /* svg {
               animation: loop 3s infinite ease-in-out;

               @keyframes loop {
                  0% { transform: rotate(0) }
                  50% { transform: rotate(180deg) }
                  100% { transform: rotate(360deg) }
               }
            } */
         }
         &.disabled {
            pointer-events: none;
         }
         span {
            margin-left: 10px;
         }
         img {
            width: 19px;
            height: 19px;
            object-fit: contain;
         }
         &:hover {
            opacity: 0.65;
         }
      }
   }
   .popup {
      display: flex;
      justify-content: center;
      align-items: center;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(30, 39, 46, 0.65);
      z-index: 99;

      > div {
         position: relative;
         background-color: #fff;
         padding: 30px;
         border-radius: 5px;
         box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);

         .close {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 25px;
            right: 30px;
            transition: all .2s ease-in-out;
            cursor: pointer;
            width: 32px;
            height: 32px;
            border-radius: 7.5px;
            opacity: 0.8;

            &:hover {
               background-color: rgba(241, 245, 249, 1);
               opacity: 1;
            }
         }
         .content {
            .title {
               display: flex;
               align-items: center;
               margin-bottom: 20px;

               .icon {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 36px;
                  height: 36px;
                  background-color: rgba(219, 234, 254, 1);
                  color: rgba(37, 99, 235, 1);
                  border-radius: 5px;
                  margin-right: 10px;
               }
               h3 {
                  font-weight: 400;
                  font-size: 19px;
               }
            }
         }
      }
   }
   .reset {
      > div {
         width: 455px;

         .content {
            .title .icon {
               background-color: rgba(254, 226, 226, 1);
               color: rgba(220, 38, 38, 1);
            }
            .info {
               > div:first-of-type {
                  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
                  background-color: rgba(254, 242, 242, 1);
                  border: 1px solid rgba(254, 202, 202, 1);
                  border-radius: 7.5px;
                  padding: 15px;
                  margin-bottom: 25px;

                  span:first-of-type {
                     display: block;
                     font-size: 15px;
                     font-weight: 500;
                     margin-bottom: 10px;
                     color: rgba(153, 27, 27, 1);
                  }
                  span:last-of-type {
                     font-size: 15px;
                     color: rgba(185, 28, 28, 1);
                  }
               }
               label {
                  display: block;
                  margin-bottom: 7.5px;
                  font-size: 16px;
               }
               .textInput {
                  margin-bottom: 25px;
                  input {
                     background-color: transparent;
                     height: 40px;
                     font-size: 15px !important;
                     box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
                     border: 1px solid rgba(226, 232, 240, 1);
                  }
               }
            }
            .tip {
               display: flex;
               font-size: 17px;
               margin-bottom: 25px;
               box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
               border-radius: 7.5px;
               padding: 15px;
               font-size: 15px;
               margin-bottom: 25px;
               line-height: 1.4;
               background-color: rgba(255, 251, 235, 1);
               border: 1px solid rgba(253, 230, 138, 1);
               color: rgba(146, 64, 14, 1);

               > span:first-of-type {
                  min-width: 28px;

                  svg {
                     color: rgba(217, 119, 6, 1);
                  }
               }
               > span:last-of-type span {
                  font-weight: 500;
               }
            }
            .action {
               display: flex;
               justify-content: space-between;

               button {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: calc((100% / 2) - 7.5px);
                  height: 40px;
                  border: 1px solid transparent;
                  border-radius: 5px;
                  background-color: rgba(220, 38, 38, 1);
                  color: #fff;
                  transition: all .2s ease-in-out;
                  cursor: pointer;
                  font-size: 14px;

                  &.cancel {
                     background-color: transparent;
                     color: initial;
                     border-color: rgba(226, 232, 240, 1);
                     box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

                     &:hover {
                        background-color: rgba(248, 250, 252, 1);
                        opacity: 1;
                     }
                  }
                  &:disabled {
                     color: rgba(100, 116, 139, 1);
                     background-color: rgba(203, 213, 225, 1);
                     opacity: 0.65;
                     cursor: default;
                     &:hover { opacity: 0.65; }
                  }
                  &:hover {
                     opacity: 0.9;
                  }
               }
            }
         }
      }
   }
`;